import { Box, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import TopHeaderClippingById from 'src/components/Retail/Headers/HeaderOnlineMediaClippingByIdRetail/Top';
import BottomHeaderClippingById from 'src/components/Retail/Headers/HeaderOnlineMediaClippingByIdRetail/Bottom';

const HeaderWrapper = styled(Box)(
  ({ theme }) => `
    color: ${theme.header.textColor};
    padding: ${theme.spacing(1, 4, 0, 4)};
    right: 0;
    z-index: 5;
    box-shadow: ${theme.header.boxShadow};
    justify-content: space-between;
    width: 100%;
    background: white;
    @media (min-width: ${theme.breakpoints.values.lg}px) {
        left: ${theme.sidebar.width};
        width: auto;
    }
`
);

function HeaderOnlineMediaClippingByIdRetail() {
  return (
    <HeaderWrapper display="flex" alignItems="center">
      <Grid container>
        <Grid item sm={12}>
          <TopHeaderClippingById />
        </Grid>
        <Grid item sm={12}>
          <BottomHeaderClippingById />
        </Grid>
      </Grid>
    </HeaderWrapper>
  );
}

export default HeaderOnlineMediaClippingByIdRetail;
